(() => {
  'use strict';

  function normalized(value) {
    return String(value || '').trim().toLowerCase();
  }

  function swatchFor(label) {
    const map = window.CB_PRODUCT_SWATCHES || {};
    if (map[label]) return map[label];
    const wanted = normalized(label);
    const key = Object.keys(map).find((name) => normalized(name) === wanted);
    return key ? map[key] : null;
  }


  function syncMainProductPicker(label) {
    const wanted = normalized(label);
    const pickers = Array.from(document.querySelectorAll('variant-selects'));

    for (const picker of pickers) {
      // Ignore any picker accidentally rendered inside the bundle widget itself.
      if (picker.closest('[class*="bundler" i], [id*="bundler" i], [class*="bundle" i], [id*="bundle" i]')) continue;

      const radios = Array.from(picker.querySelectorAll('input[type="radio"]'));
      const radio = radios.find((input) => normalized(input.value) === wanted && !input.disabled);
      if (radio) {
        if (!radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('input', { bubbles: true }));
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return true;
      }

      const selects = Array.from(picker.querySelectorAll('select'));
      for (const productSelect of selects) {
        const matchingOption = Array.from(productSelect.options).find((item) =>
          normalized(item.value) === wanted || normalized(item.textContent) === wanted
        );
        if (!matchingOption || matchingOption.disabled) continue;
        if (productSelect.value !== matchingOption.value) {
          productSelect.value = matchingOption.value;
          productSelect.dispatchEvent(new Event('input', { bubbles: true }));
          productSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return true;
      }
    }
    return false;
  }

  function isVisible(element) {
    if (!element || !element.isConnected) return false;
    let node = element;
    while (node && node.nodeType === 1) {
      const style = window.getComputedStyle(node);
      if (
        node.hidden ||
        style.display === 'none' ||
        style.visibility === 'hidden' ||
        style.opacity === '0'
      ) return false;
      node = node.parentElement;
    }
    const rect = element.getBoundingClientRect();
    return rect.width > 1 && rect.height > 1;
  }

  function looksLikeBundleSelect(select) {
    const direct = select.closest('[class*="bundler" i], [id*="bundler" i], [class*="bundle" i], [id*="bundle" i]');
    if (direct) return true;
    let node = select.parentElement;
    for (let i = 0; node && i < 6; i++, node = node.parentElement) {
      const text = (node.innerText || '').toLowerCase();
      if ((text.includes('buy 1') || text.includes('buy 2') || text.includes('buy 3') || text.includes('buy in bulk') || text.includes('save 10')) &&
          (text.includes('color') || text.includes('shade'))) return true;
    }
    return false;
  }

  function removeEnhancement(select) {
    const group = select && select._cbSwatchGroup;
    if (group && group.isConnected) group.remove();
    if (select) {
      select._cbSwatchGroup = null;
      select.dataset.cbSwatchesReady = 'false';
      select.classList.remove('cb-bundle-original-select');
    }
  }

  function enhance(select) {
    if (!select || select.options.length < 2 || !looksLikeBundleSelect(select)) return;

    // Once enhanced, the original select is intentionally reduced to 1px by our CSS.
    // Check this FIRST so our own styling is never mistaken for a hidden/unused selector.
    if (select.dataset.cbSwatchesReady === 'true' && select._cbSwatchGroup?.isConnected) return;

    // Only enhance selectors that the bundle app is currently displaying.
    // Inactive bundle choices can become visible later and will then be enhanced.
    if (!isVisible(select)) return;

    const nearbyText = ((select.previousElementSibling && select.previousElementSibling.textContent) || '') + ' ' +
      ((select.parentElement && select.parentElement.textContent) || '');
    if (!/color|shade/i.test(nearbyText)) return;

    select.dataset.cbSwatchesReady = 'true';
    select.classList.add('cb-bundle-original-select');

    const group = document.createElement('div');
    group.className = 'cb-bundle-swatch-group';
    group.setAttribute('role', 'radiogroup');
    group.setAttribute('aria-label', 'Choose a color');
    select._cbSwatchGroup = group;

    Array.from(select.options).forEach((option) => {
      if (!option.value && !option.textContent.trim()) return;
      const label = option.textContent.trim();
      const source = swatchFor(label);
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'cb-bundle-swatch';
      button.dataset.value = option.value;
      button.setAttribute('role', 'radio');
      button.disabled = option.disabled;

      const color = document.createElement('span');
      color.className = 'cb-bundle-swatch__color';
      if (source && source.image) {
        color.style.backgroundImage = `url("${String(source.image).replace(/"/g, '\\"')}")`;
        color.classList.add('has-image');
      } else if (source && source.color) {
        color.style.backgroundColor = source.color;
      } else {
        color.classList.add('is-unavailable');
      }

      const name = document.createElement('span');
      name.className = 'cb-bundle-swatch__name';
      name.textContent = label;
      button.append(color, name);

      button.addEventListener('click', () => {
        select.value = option.value;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
        // Keep Dawn's main variant picker synchronized so Shopify updates
        // the assigned product image, price, URL and availability.
        syncMainProductPicker(label);
        sync();
      });
      group.appendChild(button);
    });

    function sync() {
      group.querySelectorAll('.cb-bundle-swatch').forEach((button) => {
        const selected = button.dataset.value === select.value;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-checked', selected ? 'true' : 'false');
      });
    }

    select.addEventListener('change', sync);
    select.insertAdjacentElement('afterend', group);
    sync();
  }

  function reconcile(root = document) {
    root.querySelectorAll('select').forEach((select) => {
      if (looksLikeBundleSelect(select)) enhance(select);
    });
  }

  let scheduled = false;
  function scheduleReconcile() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      reconcile();
    });
  }

  const observer = new MutationObserver(scheduleReconcile);

  function init() {
    reconcile();
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']
    });
    document.addEventListener('click', () => setTimeout(scheduleReconcile, 40), true);
    document.addEventListener('change', () => setTimeout(scheduleReconcile, 40), true);
    window.addEventListener('resize', scheduleReconcile);
    [300, 800, 1500, 3000].forEach((delay) => setTimeout(scheduleReconcile, delay));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
